var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meta-insights-performance" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title-block" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("metaInsights.performanceTitle"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("metaInsights.performanceSubtitle"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "160px" },
              on: { change: _vm.onMetricChange },
              model: {
                value: _vm.metric,
                callback: function ($$v) {
                  _vm.metric = $$v
                },
                expression: "metric",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "impressions" } }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("metaInsights.kpi.impressions")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "reach" } }, [
                _vm._v(_vm._s(_vm.$t("metaInsights.kpi.reach"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "clicks" } }, [
                _vm._v(_vm._s(_vm.$t("metaInsights.kpi.clicks"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "spend" } }, [
                _vm._v(_vm._s(_vm.$t("metaInsights.kpi.spend"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("DateRangePicker", {
            on: { change: _vm.onDateRangeChange },
            model: {
              value: _vm.dateRange,
              callback: function ($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "", disabled: _vm.loading },
              on: { click: _vm.loadAll },
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  class: { spinning: _vm.loading },
                },
                [_vm._v("refresh")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("metaInsights.refresh")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid" },
      [
        _c("BreakdownChart", {
          attrs: {
            title: _vm.$t("metaInsights.breakdown.publisherPlatform"),
            rows: _vm.platformRows,
            "breakdown-key": "publisher_platform",
            metric: _vm.metric,
            "chart-type": "pie",
            loading: _vm.loadingPlatform,
            "label-map": _vm.platformLabels,
            currency: _vm.currency,
          },
        }),
        _vm._v(" "),
        _c("BreakdownChart", {
          attrs: {
            title: _vm.$t("metaInsights.breakdown.platformPosition"),
            rows: _vm.positionRows,
            "breakdown-key": "platform_position",
            metric: _vm.metric,
            "chart-type": "bar",
            loading: _vm.loadingPosition,
            currency: _vm.currency,
          },
        }),
        _vm._v(" "),
        _c("BreakdownChart", {
          attrs: {
            title: _vm.$t("metaInsights.breakdown.device"),
            rows: _vm.deviceRows,
            "breakdown-key": "impression_device",
            metric: _vm.metric,
            "chart-type": "bar",
            loading: _vm.loadingDevice,
            currency: _vm.currency,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }